import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoCompleteDenialCategoryComponent } from './auto-complete-denial-category.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DenialCategoryModule } from '../denial-category/denial-category.module';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DenialCategoryModule,
    Trip2ThemeModule
  ],
  declarations: [AutoCompleteDenialCategoryComponent],
  exports: [AutoCompleteDenialCategoryComponent]
})
export class AutoCompleteDenialCategoryModule { }



// WEBPACK FOOTER //
// ./src/app/utils/auto-complete-denial-category/auto-complete-denial-category.module.ts